module.exports = __webpack_public_path__ + "img/Workflow_Image.1da78efe.png";